import React, { Component } from 'react'
import { Col, Row, Label } from 'reactstrap'
import { observer } from 'mobx-react';
import { formatNullableValue } from '../../../../../utils/formatar';

@observer
export default class CardDetalheServico extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selecionado: this.props.data.selecionado
        };

        this.marcar = this.marcar.bind(this);
    }


    marcar() {
        this.setState({
            selecionado: !this.state.selecionado
        });

        this.props.selecionar(this.props.data);
    }

    renderFields(col) {
        if(col.formatter) {
            return (
                <div className="info bg-cinza">
                    <div className="titulo">{col.text}</div>
                    <div className="valor">
                        {formatNullableValue( col.formatter(this.props.data[col.dataField], this.props.data))}
                    </div>
                </div>
            );
        } else {
            return (
                <div className="info bg-cinza">
                    <div className="titulo">{col.text}</div>
                    <div className="valor">
                        {formatNullableValue(this.props.data[col.dataField], this.props.data)}
                    </div>
                </div>
            );
        }
    }

    render() {
        return (
            <Col xs={12} md={6} lg={4} className="px-0">
                <div className={`card-navio ${this.state.selecionado ? "card-detalhe-servico-mobile" : ""}`} onClick={this.marcar}>
                    <Row xs={12} className="px-0">
                       {
                           this.props.colunas.map((col, index) => {
                                return(
                                    <Col xs={12} className="px-0" key={index}>
                                        {this.renderFields(col)}
                                    </Col>
                                )
                           })
                       }
                    </Row>
                </div>
            </Col>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/faturamento/orcamento/importacao/components/CardDetalheServico.js